import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { parameterizeDynamicsControlMetadata } from '../consts/metadata-consts';
import { clientId, clientSecret, endpoint, password, username } from './servicenow-metadata';
import { GlobalVariables } from 'app/services/globals';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { ConnectionAuthKind, getConnectorV2Name, serviceNowAuthTypes } from 'shell-models-lib';

export const serviceNowV2Metadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.serviceNowV2.linkedServiceType,
    displayName: getConnectorV2Name(stringResources.ServiceNow_DisplayText, __IS_FABRIC_DPE__),
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-servicenow'
    },
    isFirstClass: true,
    linkedServiceNamePrefix: adfModelTypeMap.serviceNow.linkedServiceType,
    supportDatasetV2: true,
    supportedInTrident: true,
    supportAutoFillCopilotInput: true,
    isKnownInPipelineContext: true,
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.Extension,
        resourceKind: 'ServiceNow' as ResourceKind
    },
    supportedAuthKindsInTrident: [
        ConnectionAuthKind.Basic
    ],
    supportOPDG: GlobalVariables.enableOPDG,
    supportCopyJobSource: true,
    supportedJobModesAsSource: GlobalVariables.copyJobIncrementalCopyPhase2 ? undefined : ['Batch'],
    category: ['ServicesApps'],
    copySinkTypes: [],
    copySourceTypes: [adfModelTypeMap.serviceNowV2.copySourceType],
    supportFirstClassParameterExperience: true,
    controls: [
        parameterizeDynamicsControlMetadata(endpoint),
        {
            type: 'select-switch',
            bind: 'authenticationType',
            label: stringResources.ModelName_AuthenticationType,
            options: [
                {
                    label: stringResources.Basic_DisplayText,
                    value: serviceNowAuthTypes.Basic
                },
                {
                    label: stringResources.AuthenticationType_OAuth2,
                    value: serviceNowAuthTypes.OAuth2
                }
            ],
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true,
            defaultValue: serviceNowAuthTypes.Basic,
            cases: [
                {
                    caseValue: serviceNowAuthTypes.Basic,
                    children: [
                        parameterizeDynamicsControlMetadata(username),
                        parameterizeDynamicsControlMetadata(password)
                    ]
                },
                {
                    caseValue: serviceNowAuthTypes.OAuth2,
                    children: [
                        parameterizeDynamicsControlMetadata(username),
                        parameterizeDynamicsControlMetadata(password),
                        parameterizeDynamicsControlMetadata(clientId),
                        parameterizeDynamicsControlMetadata(clientSecret),
                    ]
                }
            ]
        }
    ]
};
